import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-start px-6 pt-12 pb-8 text-center" data-id="element-90">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-91">
        <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-light mb-8 leading-tight" data-id="element-92">
          Más Que Padres: <br className="hidden md:block" data-id="element-93" />
          <span className="text-brand-accent italic font-normal" data-id="element-94">
            El Protocolo de 180 Segundos
          </span>{' '}
          <br className="hidden md:block" data-id="element-95" />
          para Recuperar tu Pareja
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative w-full max-w-[240px] md:max-w-[280px] aspect-[2/3] rounded-lg overflow-hidden shadow-2xl shadow-brand-accent/10 border border-brand-light/10" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/1teGerwfjJyXWCynKXJD7s/portada.png" alt="Más Que Padres - El Método de los 180 Segundos" className="w-full h-full object-cover" data-id="element-97" />
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1
    }} className="mt-6 animate-bounce text-brand-light/50 cursor-pointer" onClick={() => document.getElementById('offer-cta')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-98">
        <ChevronDown className="w-8 h-8" data-id="element-99" />
      </motion.div>
    </section>;
}